import request from '@/utils/request';

/* 获取首页信息 */
export function homeApi(params) {
    return request({
        url: `/api/v1/index?version_code=${params.version_code}`,
        method: 'get',
        data: params
    })
}

/* 获取轮播图信息 */
export function bannerApi(params) {
    return request({
        url: `/api/banner`,
        method: 'get',
        data: params
    })
}

/* 获取最新课程 */
export function getCourseNew(params) {
    return request({
        url: `/api/course/new?pageNum=${params.pageNum}&pageSize=${params.pageSize}`,
        method: 'get',
        data: params
    })
}

/* 获取最热课程 */
export function getCourseRanking(params) {
    return request({
        url: `/api/course/ranking?pageNum=${params.pageNum}&pageSize=${params.pageSize}`,
        method: 'get',
        data: params
    })
}

/* 获取通知公告 */
export function getNotice(params) {
    return request({
        url: `/api/notice?pageNum=${params.pageNum}&pageSize=${params.pageSize}`,
        method: 'get',
        data: params
    })
}

/* 观看时长排行榜 */
export function getRanking(params) {
    return request({
        url: `/api/user/ranking?pageNum=${params.pageNum}&pageSize=${params.pageSize}`,
        method: 'get',
        data: params
    })
}

/* 获取网站信息 */
export function getWebInfo(params) {
    return request({
        url: `/api/webInfo`,
        method: 'get',
        data: params
    })
}

/* 新增访问记录 */
export function accessRecord(params) {
    return request({
        url: `/api/accessRecord`,
        method: 'post',
        data: params
    })
}










